var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('AsiChip',{attrs:{"color":_vm.color,"icon":!_vm.hideIcon ? _vm.icon : undefined,"label":"","small":""}},[_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }